import axios from 'axios';
import Cookies from 'cookies-js';
// import MockAdapter from 'axios-mock-adapter';
import config from '../config';
import { attachAccountNotVerifiedInterceptor } from './emailVerification';

// UT_API-backed instances (API, Leagues API and their proxies) send members who must verify their
// email to the verify screen on a 403 account_not_verified. The generic and search instances do not.
export const getProxyAxiosInstance = () => {
    return attachAccountNotVerifiedInterceptor(
        axios.create({
            baseURL: '/api',
        })
    );
};

export const getApiAxiosInstance = () => {
    if (config.useProxy) {
        return getProxyAxiosInstance();
    }
    return attachAccountNotVerifiedInterceptor(
        axios.create({
            baseURL: config.apiHost,
            withCredentials: true,
        })
    );
};

export const getAxiosInstance = () => {
    return axios.create({});
};

export const getLeaguesProxyAxiosInstance = () => {
    return attachAccountNotVerifiedInterceptor(
        axios.create({
            baseURL: '/leagues-api',
        })
    );
};

export const getLeaguesApiAxiosInstance = () => {
    if (config.useProxy) {
        return getLeaguesProxyAxiosInstance();
    }
    return attachAccountNotVerifiedInterceptor(
        axios.create({
            baseURL: config.leaguesApiHost,
            withCredentials: true,
        })
    );
};

export const getSearchProxyAxiosInstance = () => {
    return axios.create({
        baseURL: '/search-api',
    });
};

export const getSearchApiAxiosInstance = () => {
    if (config.useProxy) {
        return getSearchProxyAxiosInstance();
    }
    const instance = axios.create({
        baseURL: config.searchApiHost,
        withCredentials: true,
    });
    instance.interceptors.request.use((reqConfig) => {
        const jwt = Cookies.get('jwt');
        if (jwt) {
            reqConfig.headers.Authorization = `Bearer ${jwt}`;
        }
        return reqConfig;
    });
    return instance;
};

// export const axiosMock = () => {
//     const axiosInstance = axios.create({});
//     const mock = new MockAdapter(axiosInstance);
//     return {
//         mock,
//         axiosInstance,
//     };
// };
